import React, { Component, Fragment } from 'react';

import proj from '../main-page-project/MainPageProject.css'
import styles from './MainPageEtsy.css'
import fonts from '../../../styles/fonts.css'

import wovenBagImage from '../../../assets/img/main-page/etsy-woven-bag.png'
import floralThrowImage from '../../../assets/img/main-page/etsy-floral-throw.png'
import clayKitImage from '../../../assets/img/main-page/etsy-clay-kit.png'
import greenLampImage from '../../../assets/img/main-page/etsy-green-lamp.png'

// Recommendations strip items: real cropped Etsy item photos rendered as a
// plain <img> filling the square thumbnail (object-fit: cover via CSS).
const RECS = [
    { name: 'woven bag',    score: '.94', image: wovenBagImage },
    { name: 'floral throw', score: '.91', image: floralThrowImage },
    { name: 'clay kit',     score: '.89', image: clayKitImage },
    { name: 'green lamp',   score: '.87', image: greenLampImage },
];

class MainPageEtsy extends Component {
    render() {
        return (
            <Fragment>
                <div className={proj.project}>
                    <div className={[fonts["title-bold"], proj["project-title"]].join(' ')}>
                        <span className={proj.prompt}>&gt;</span>
                        <span>etsy</span>
                        <span className={styles["now-badge"]}>now</span>
                    </div>
                    <div className={[proj["project-body"], proj["dir-media-right"]].join(' ')}>
                        <div className={proj["project-text"]}>
                            <div className={proj.paragraph}>
                                Sr. machine learning engineer on Etsy Recommendations. I build the
                                path that takes recommendation models from a scientist&rsquo;s
                                notebook to production serving 90+ million shoppers -
                                candidate retrieval, real-time inference pipelines, and LLM-powered
                                understanding of items and queries across 100M+ one-of-a-kind listings.
                            </div>
                            <div className={proj['appstores']}>
                                <a className={[fonts["title"], proj['appstore']].join(' ')}
                                   href="https://www.etsy.com" target="_blank" rel="noopener noreferrer">
                                    <svg className={proj["appstore-icon"]} aria-hidden="true" role="img"
                                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2"
                                         strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <line x1="2" y1="12" x2="22" y2="12"></line>
                                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                    etsy.com
                                </a>
                            </div>
                        </div>
                        <div className={proj["project-media"]}>
                            <div className={styles["recs-panel"]}>
                                <div className={[fonts["title"], styles["recs-header"]].join(' ')}>
                                    $ recs --user u_4f2a
                                </div>
                                <div className={styles["recs-row"]}>
                                    {RECS.map(function (r, i) {
                                        return (
                                            <div className={styles["rec-card"]} key={i}>
                                                <div className={styles["rec-thumb"]}>
                                                    <img src={r.image} alt={r.name} />
                                                </div>
                                                <div className={styles["rec-meta"]}>
                                                    <span className={[fonts["title"], styles["rec-name"]].join(' ')}>{r.name}</span>
                                                    <span className={[fonts["title"], styles["rec-score"]].join(' ')}>{r.score}</span>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default MainPageEtsy;
